// extracted by mini-css-extract-plugin
export default {"wrapper":"Popup_wrapper__rchFH","fadeWrapperIn":"Popup_fadeWrapperIn__Wxn+y","popup":"Popup_popup__TSFIy"};